module.exports = __webpack_public_path__ + "img/venueone-priceexam.91d2538a.png";